module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!--房型信息模板-->\r\n\r\n<div class="hotel-info-wrap">\r\n	<ul class="hotel-info-list">\r\n		';
 if(roomName && roomName !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<i class="iconfont icon-home"></i>\r\n			<h1 class="roomName">' +
((__t = ( roomName )) == null ? '' : __t) +
'</h1>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(floor && floor !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>楼层：</label>\r\n			<span>' +
((__t = ( floor )) == null ? '' : __t) +
'层</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(acreage && acreage !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>面积：</label>\r\n			<span>' +
((__t = ( acreage )) == null ? '' : __t) +
'm²</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(bedName && bedName !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>床型：</label>\r\n			<span>' +
((__t = ( bedName )) == null ? '' : __t) +
'</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(bedWidth && bedWidth !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>床型大小：</label>\r\n			<span>' +
((__t = ( bedWidth )) == null ? '' : __t) +
'm</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(maximize && maximize > 0){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>最大入住人数：</label>\r\n			<span>' +
((__t = ( maximize )) == null ? '' : __t) +
'人</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(facilities && facilities !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>房间设施：</label>\r\n			<span>' +
((__t = ( facilities )) == null ? '' : __t) +
'</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n\r\n		';
 if(comment && comment !== ''){ ;
__p += '\r\n		<li class="hotel-info-item">\r\n			<label>房型备注：</label>\r\n			<span>' +
((__t = ( comment )) == null ? '' : __t) +
'</span>\r\n		</li>\r\n		';
 } ;
__p += '\r\n	</ul>\r\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/hotelPriceUtil/templates/roomInfoTipTmpl.ejs
// module id = 84
// module chunks = 1 2 3 6 10